import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <main className="min-h-screen bg-background-50 flex items-center justify-center px-4">
      <div className="text-center">
        <div className="w-20 h-20 flex items-center justify-center bg-primary-100 rounded-2xl mx-auto mb-6">
          <i className="ri-error-warning-line text-primary-500 text-3xl"></i>
        </div>
        <h1 className="text-3xl md:text-4xl font-bold text-foreground-950 mb-3">
          404
        </h1>
        <p className="text-sm md:text-base text-foreground-600 mb-6">
          Strona nie została znaleziona
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-all duration-200"
        >
          <i className="ri-home-line"></i>
          Strona główna
        </Link>
      </div>
    </main>
  );
}